/**
 * The gateway, handed down.
 *
 * One context, set once at the root, so no screen constructs a client and every suite can
 * mount a screen against the in-memory gateway with no network and no mocking of `fetch`.
 * Reading it outside the provider throws rather than returning `undefined`: a screen with
 * no gateway has nothing to render and should say so at the seam, not three frames later.
 */
import { createContext, use, type ReactNode } from "react";

import type { ConsoleGateway } from "./gateway.js";

const GatewayContext = createContext<ConsoleGateway | null>(null);

export function GatewayProvider({
  gateway,
  children,
}: {
  readonly gateway: ConsoleGateway;
  readonly children: ReactNode;
}): ReactNode {
  return <GatewayContext value={gateway}>{children}</GatewayContext>;
}

export function useGateway(): ConsoleGateway {
  const found = use(GatewayContext);
  if (found === null) {
    throw new Error("No ConsoleGateway in context. Mount <GatewayProvider> above this screen.");
  }
  return found;
}
